"use client";

import { ReactNode } from "react";

import { CoverPresentation } from "@/components/uploadFilePresentation/CoverPresentation";
import { SelectedFile } from "@/types/defs/selectedFile";
import { AudioInputState } from "@/types/types";
import { isSelectedCover } from "@/utils/selectedFileCover/is/isSelectedCover";

export function UploadFilePresentation({
  selectedFileCover,
  clearInput,
  hideClearButton,
  renderFilePresentation,
}: {
  selectedFileCover: AudioInputState["selectedFileCover"];
  clearInput: AudioInputState["clearInput"];
  hideClearButton: boolean;
  renderFilePresentation: (selectedFile: SelectedFile) => ReactNode;
}) {
  if (selectedFileCover === null) {
    return null;
  }

  if (isSelectedCover(selectedFileCover)) {
    return (
      <CoverPresentation
        selectedCover={selectedFileCover}
        clearInput={clearInput}
        hideClearButton={hideClearButton}
      />
    );
  }

  return renderFilePresentation(selectedFileCover);
}
